module.exports = __webpack_public_path__ + "img/landing_bg_colored_01.068417a2.jpg";